import clsx from "clsx";
import { useEffect, useState } from "react";

const defaultStates = [
  {
    icon: <i className="ki-filled ki-check text-white"></i>,
    value: "yes",
    className: "bg-brand border-bg-brand",
  },
  {
    icon: <i className="ki-filled ki-minus text-white"></i>,
    value: "partial",
    className: "bg-warning border-warning",
  },
  {
    icon: <i className="ki-filled ki-cross text-white"></i>,
    value: "no",
    className: "bg-[#8D4F61] border-[#8D4F61]",
  },
];

export type MultiStateValue = string | number | null;
export interface CheckboxStateValue {
  value: MultiStateValue;
  stateName: string;
}
export interface MultiCheckboxProps {
  states?: {
    icon: React.ReactNode;
    value: MultiStateValue;
    className?: React.HTMLAttributes<HTMLButtonElement>["className"];
  }[];
  onChange?: (e: CheckboxStateValue) => void;
  value?: MultiStateValue;
  stateName: string;
}
export function MultiCheckbox({
  states = defaultStates,
  onChange,
  value,
  stateName,
}: MultiCheckboxProps) {
  const [activeState, setActiveState] = useState<MultiStateValue>(null);

  useEffect(() => {
    setActiveState(value ?? null);
  }, [value]);

  return (
    <div className="h-6 flex space-x-1 gap-2">
      {states.map((state) => (
        <button
          key={state.value}
          type="button"
          className={clsx(
            "w-6 h-6 rounded-md border-[1px]",
            activeState === state.value ? state.className : "",
          )}
          onClick={() => {
            if (value === undefined) setActiveState(state.value);
            onChange?.({ value: state.value, stateName: stateName });
          }}
          name={stateName}
        >
          {state.icon}
        </button>
      ))}
    </div>
  );
}
